import React, { useEffect, useMemo, useState } from "react"
import { MainContainer, NextUITable, ErrorCard, LoadingCard, VirtualizeAutoComplete } from "../../components"
import {
  Button,
  Autocomplete,
  AutocompleteItem
} from "@nextui-org/react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file

import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { resetGrayFilter, setCurrentGrayStock, setFilter } from "../../state/grayStockSlice.jsx"
import { calculateTotal } from "../../Utility/utility.js"
import { COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable.jsx"
import { isMobile } from "react-device-detect"

const GrayStock = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const enum_filterFieldId = {
    item: "itemCode",
    mitem: "mitemCode",
    unit: "unitId"
  }
  const { currentGrayStock, filter } = useSelector((state) => state.grayStock)
  const [filterDate, setFilterDate] = useState({
    start:  filter?.fromdate || null,
    end: filter?.todate || null,
  })
  console.log(filter, "fill")
  //const [data, setData] = useState([])
  const [selectedItem, setSelectedItem] = useState(filter?.itemCode || "")
  // { key: filter && filter.itemCode ? filter.itemCode : "", value: filter && filter.itemName ? filter.itemName : "" }
  const [selectedMitem, setSelectedMitem] = useState(filter?.mitemCode || "")
  const [selectedUnit, setSelectedUnit] = useState(filter?.unitId || "")
  // key: filter && filter.mitemCode ? filter.mitemCode : "", value: filter && filter.mitemName ? filter.mitemName : "" 
  const { compCode } = useSelector((state) => state.company)


  const { isLoading, isError: isErrorFetch, data: itemDetails = [] } = useFetchWithBody({
    url: apiRoute.grayStock.fetchItemMaster,
    queryKey: "GrayStockItemMaster",
  })

  const {
    isPending,
    isError,
    data: grayStock = [],
    mutate: filterGrayStock,
  } = usePost({
    url: apiRoute.grayStock.fetch,
    queryKey: "GrayStock",
  })
  const { data: unitMaster = [] } = useFetchWithBody({
    url: apiRoute.report.invoice.getUnit,
    queryKey: "Fetch Unit data",
    inputData: {
      compcode: compCode.join(",")
    }
  })
  const handleVirtualizeChanged = (data) => {
    // let id = data.id

    // if (id == enum_filterFieldId.item)
    //   setSelectedItem({ key: data.selectedKey, value: data.selectedValue })
    // else if (id == enum_filterFieldId.mitem)
    //   setSelectedMitem({ key: data.selectedKey, value: data.selectedValue })
  }
  let totalTaka = useMemo(
    () =>
      calculateTotal({
        data: grayStock,
        columnName: "Taka",
      }),
    [grayStock]
  )
  let totalMeter = useMemo(
    () =>
      calculateTotal({
        data: grayStock,
        columnName: "Meter",
      }),
    [grayStock]
  )

  let downloadDataFooter = {
    item_code: "",
    item_desc: "",
    Taka: "Total: " + totalTaka,
    Meter: "Total: " + totalMeter,
  }

  const exportColumns = [
    {
      uid: "item_code",
      name: "Item Code",
    },
    {
      uid: "item_desc",
      name: "Item Desc",
    },
    {
      uid: "Taka",
      name: "Taka",
    },
    {
      uid: "Meter",
      name: "Meter",
    },
  ]

  useEffect(() => {
    funFilterData();
  }, [])

  console.log(unitMaster, "unis")

  // useEffect(() => {
  //   setData(grayStock)
  //  }, [grayStock])
  //console.log(compCode.join(","),compCode,"gg")
  const funFilterData = () => {
    filterGrayStock({
      data: {
        compcode: compCode.join(","),
        from_date: filterDate.start
          ? new Date(filterDate.start).toISOString().split("T")[0]
          : null,
        to_date: filterDate.end
          ? new Date(filterDate.end).toISOString().split("T")[0]
          : null,
        unit_id: selectedUnit || null,
        item_code: selectedItem != null && selectedItem && selectedItem !== "" && selectedItem !== "0" ? selectedItem : null,
        mitem_code: selectedMitem != null && selectedMitem && selectedMitem !== "" && selectedMitem != "0" ? selectedMitem : null,
        chal_no: null,
        action: "SUMMARY",
      },
    })
  }
  const handleFilter = () => {
    funFilterData()
  }

  const handleResetFilter = () => {
    setSelectedItem("")
    //{ key: "", value: "" }
    setSelectedMitem("")
    setFilterDate({start:null,end:null})
    setSelectedUnit("")
    dispatch(resetGrayFilter())
    filterGrayStock({
      data: {
        compcode: compCode.join(","),
        fromdate: null,
        todate: null,
        item_code: null,
        mitem_code: null,
        chal_no: null,
        action: null,
      },
    })
  }

  const INITIAL_VISIBLE_COLUMNS = ["item_code", "item_desc", "Taka", "Meter"]

  const columns = [
    {
      uid: "item_code",
      name: "Item Code",
      sortable: true,
    },
    {
      uid: "item_desc",
      name: "Item Desc",
      sortable: true,

      type: COLUMN_TYPE.link,
      onClick: (row) => {
        dispatch(
          setCurrentGrayStock({
            item_code: row.item_code,
          })
        )

        dispatch(setFilter({
          itemCode: selectedItem,
          mitemCode: selectedMitem,
          itemName: "",
          mitemName: "",
          unitId: selectedUnit,
          fromdate: filterDate.start,
          todate: filterDate.end,
        }))
        // setFilter({
        //   itemCode: selectedItem,
        //   mitemCode: selectedMitem,
        //   //  itemName: selectedItem.value,
        //   // mitemName: selectedMitem.value,
        //   fromdate: filterDate.start,
        //   todate: filterDate.end,
        // })
        // )
        navigate(linksUrl.grayStock.detail)
      },
    },
    {
      uid: "Taka",
      name: "Taka",
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTaka,
      },
    },
    {
      uid: "Meter",
      name: "Meter",
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalMeter,
      },
    },
  ]


  if (isPending) {
    return <LoadingCard />
  }

  if (isError || isErrorFetch) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Gray Stock" info={[]} breadcrumbs={["Gray Stock"]}>
        {/* filter */}
        <div className="flex flex-wrap  gap-2 mb-2 bg-gray-10 shadow p-3">
          {/* filter */}

          {/* <div id="filter" className=" flex flex-wrap items-center   gap-4 "> */}
          {/* date */}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={"Start Date"}
              views={["day", "month", "year"]}
              format="DD/MM/YYYY"
              value={
                filterDate.start
                  ? dayjs(filterDate.start)
                  : filterDate.start
              }
              onChange={(newValue) => {
                setFilterDate((prev) => {
                  return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                })
              }}
              sx={{ width: "145px" }}
              slotProps={{ textField: { size: "small" } }}
            />
            <DatePicker
              label={"End Date"}
              views={["day", "month", "year"]}
              format="DD/MM/YYYY"
              value={
                filterDate.end ? dayjs(filterDate.end) : filterDate.end
              }
              onChange={(newValue) => {
                setFilterDate((prev) => {
                  return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                })
              }}
              slotProps={{ textField: { size: "small" } }}
              sx={{ width: "145px" }}
            />
          </LocalizationProvider>
          {/*  end of date */}
          <div className={`${isMobile ? "flex-wrap" : ""} flex  items-center gap-2 `}>
            <Autocomplete
              size="sm"
              name={enum_filterFieldId.unit}
              // isInvalid={errors[item.name]}
              // errorMessage={errors[item.name]}
              label={"Unit"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className="max-w-23"
              color="warning"
              isClearable={true}
              variant="flat"
              isVirtualized
              defaultItems={
                unitMaster || []
              }
              onSelectionChange={setSelectedUnit}
              selectedKey={selectedUnit}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Party_Id}
                >
                  {list.Party_Name}
                </AutocompleteItem>
              )}
            </Autocomplete>
            <Autocomplete
              size="sm"
              name={enum_filterFieldId.item}
              label={"Item Name"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className={`${isMobile ? "w-full" : "max-w-42"} `}
              isClearable={true}
              variant="bordered"
              isVirtualized
              defaultItems={
                itemDetails && itemDetails.itemMaster
                  ? itemDetails.itemMaster
                  : []
              }
              onSelectionChange={setSelectedItem}
              selectedKey={selectedItem}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Item_Code}
                >
                  {list.Item_CodeNDesc}
                </AutocompleteItem>
              )}
            </Autocomplete>
            <Autocomplete
              size="sm"
              name={enum_filterFieldId.item}
              label={"M Item Name"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className={`${isMobile ? "w-full" : "max-w-42"} `}
              isClearable={true}
              variant="bordered"
              isVirtualized
              defaultItems={
                itemDetails && itemDetails.mitemMaster
                  ? itemDetails.mitemMaster
                  : []
              }
              onSelectionChange={setSelectedMitem}
              selectedKey={selectedMitem}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Item_Code}
                >
                  {list.Item_CodeNDesc}
                </AutocompleteItem>
              )}
            </Autocomplete>

          </div>

          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
            onPress={handleFilter}

          // isLoading={isPending}
          >
            Search
          </Button>
          <Button
            size="sm"
            style={{ marginLeft: "5px" }}
            color="primary"
            startContent={<FontAwesomeIcon icon={faFilter} />}
            onPress={handleResetFilter}

          >
            Reset
          </Button>
          {/* </div> */}

          {/* end of filter */}
        </div>

        {/* end of filter */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={grayStock}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Gray_Stock"
          showAdvanceFilter={false}
          id="item_code"
        />
      </MainContainer>
    </div>
  )
}

export default GrayStock
